import { inject, Injectable } from '@angular/core';
import { FuseConfig } from '@fuse/services/config/config.types';
import { FUSE_CONFIG } from '@fuse/services/config/config.constants';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FuseConfigService {
    private _config = new BehaviorSubject<FuseConfig>(inject(FUSE_CONFIG));

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    set config(value: Partial<FuseConfig>) {
        // Merge the new config over to the current config
        const config = merge({}, this._config.getValue(), value) as FuseConfig;

        // Execute the observable
        this._config.next(config);
    }


    get config$(): Observable<FuseConfig> {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void {
        // Set the config
        this._config.next(this._config.getValue());
    }
}
